import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInternationalCountries } from '../actions';
import { IStore } from '../store';

export const useAvailableCountries = () => {
  const dispatch = useDispatch();
  const countries = useSelector((store: IStore) => store.client.availableCountries);
  const alpha3CountryCodes = (countries ?? []).map((country) => country.IsoCode);

  useEffect(() => {
    dispatch<any>(fetchInternationalCountries());
  }, []);

  return { countries, alpha3CountryCodes };
};
